angular.module( 'acme.view.pageNotFound', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.pageNotFound.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var pageNotFound = {
        name: 'pageNotFound',
        url: '/pageNotFound',
        views: {
          "main": {
            controller: 'PageNotFoundController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/pageNotFound/pageNotFound.tpl.html'
          }
        },
        data: {
          pageTitle: 'Page not found'
        }
      };

    $stateProvider
      .state(pageNotFound);
});
